export default __webpack_public_path__ + "media/images/icons/1-flight-03a3bee0a370a33d6ed501ae5f4bf89a.png";